/** Build an official Google Maps search link for an address. */
export function mapsUrl(query) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

// A location may carry a `url` — a share link to its actual Google Maps place,
// which lands on the registered pin (unit and business name included) rather
// than whatever a text search happens to match. Without one, `query` is
// searched instead.
export const locations = [
  {
    label: "Office",
    name: "Stellar @ Tampines",
    lines: ["12 Tampines North Drive 4, #07-04A", "Singapore 529435"],
    url: "https://maps.app.goo.gl/bfx26coKVC8wHdVi6",
    query: "Stellar @ Tampines, 12 Tampines North Drive 4, Singapore 529435",
  },
  {
    label: "Workshop",
    name: "Sin Ming Industrial Estate",
    lines: ["30 Sin Ming Drive #01-243", "Singapore 575704"],
    query: "30 Sin Ming Drive #01-243, Singapore 575704",
  },
];

export const email = "hello@eikainteriors.com";
export const instagram = "https://www.instagram.com/eika_interiors/";
export const instagramHandle = "@eika_interiors";

/** WhatsApp number in international format — no "+", spaces, or dashes. */
export const whatsapp = "6565560837";
export const whatsappMessage = "Hi EIKA, I'd love to talk about my home.";

/** EIKA's Google Business listing. */
export const googleListing = "https://maps.app.goo.gl/pb8EnUbWe3JtAJVw6";

// ---------------------------------------------------------------------------
// ⚠️ UNVERIFIED — confirm against the ACRA/BizFile record before going live.
// Supplied as "I think is from 1997". A wrong founding year is a false
// credential on a real business, and it's publicly checkable on BizFile.
//
// Years in business are derived from this, so the site never goes stale — fix
// this one number and every mention updates.
// ---------------------------------------------------------------------------
export const foundedYear = 1997;
export const yearsInBusiness = new Date().getFullYear() - foundedYear;

// ---------------------------------------------------------------------------
// Contact form (Web3Forms)
//
// This key is PUBLIC by design (Web3Forms expects it in frontend code). It only
// permits submissions to the address the key was issued for — it is not a secret.
// ---------------------------------------------------------------------------
export const web3formsKey = "9695b6f8-2959-4023-a48e-47fda321b40f";
export const web3formsEndpoint = "https://api.web3forms.com/submit";

// ---------------------------------------------------------------------------
// Enquiry form options. Edit these lists to change the dropdowns — the form
// renders whatever is here.
// ---------------------------------------------------------------------------
export const propertyTypes = ["HDB", "Condominium", "Landed", "Commercial"];

export const completionOptions = ["ASAP", "Within 3 months", "3–6 months", "Flexible"];

// Consultation slots offered on the enquiry form. These are the bands EIKA is
// willing to meet in — not live availability, so the team still confirms.
export const appointmentTimes = [
  "Morning 10am - 12pm",
  "Lunch Hour 12pm - 2pm",
  "Afternoon 2pm - 4pm",
  "Late Afternoon- 4pm-6pm",
  "Evening (After Hour)* 7pm-9pm"
];

// ⚠️ Budget bands are my estimate of the Singapore market, NOT EIKA's figures.
// Confirm these match the work they actually take on before going live.
export const budgetOptions = [
  "$30,000 – $50,000",
  "$50,000 – $80,000",
  "$80,000 – $120,000",
  "Above $120,000",
  "Not sure yet",
];

// Web3Forms' SHARED hCaptcha sitekey for free plans — the same value for every
// free user, and it is meant to be public. It pairs with Web3Forms' own secret,
// which lives on their server, so there is nothing for us to host or hide.
//
// Don't swap in a personal hCaptcha sitekey: custom keys are Pro-only, and on
// the free plan their secret can't verify a token minted by another sitekey —
// every submission would be rejected.
//
// IMPORTANT: rendering the widget is only half of it. hCaptcha must also be
// switched on at https://app.web3forms.com for it to be *enforced*; until then
// a scripted POST that omits the token is still accepted.
export const hcaptchaSitekey = "50b2fe65-b00b-4b9e-ad62-3ba471098be2";
